import { Heading, HeadingProps } from '@chakra-ui/react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useUserEventTimezone } from '@/hooks/useUserEventTimezone';
import { ThinEvent } from '@/resources/ThinEvent';
import { formatConferenceDate } from '@/utils/date';

interface IEventDurationWithTimezoneProps extends HeadingProps {
  event: ThinEvent;
}

export const EventDurationWithTimezone: FC<IEventDurationWithTimezoneProps> = ({ event, ...props }) => {
  const { t } = useTranslation();
  const defaultTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const userEventTimezone = useUserEventTimezone(event.id);

  const selectedTimezone = userEventTimezone || defaultTimezone;

  const formattedDuration = formatConferenceDate(event, selectedTimezone);

  return (
    <Heading
      title={t('common.timezoneTooltip', {
        timezone: userEventTimezone || defaultTimezone,
        interpolation: { escapeValue: false },
      })}
      as="p"
      fontSize={['md', null, 'xl']}
      lineHeight="shorter"
      {...props}
    >
      {formattedDuration}
    </Heading>
  );
};
